import { useSelector } from "react-redux";
import "./SelectionPath.css";

/**
 * A uniform breadcrumb of the user's choices, accumulating with leading dots as
 * the flow progresses:  · מחלקה · שירות  — only the parts chosen so far show.
 * Used on both the booking steps and the edit screen so they look identical.
 */
/* ★ `departmentTitle` הוא הערך שנוסע עם התור עצמו, ולכן הוא גובר.
   ⚠️ במסך-העריכה חובה להעביר אותו: החיפוש ב-`user.departments` מוצא רק
      מחלקות **פתוחות להזמנה**, ולכן תור במחלקה שנסגרה איבד את שמה
      מפירורי-הלחם. בטופס-ההזמנה אין צורך — שם המחלקה פעילה בהגדרה. */
export default function SelectionPath({ departmentId, departmentTitle, serviceTitle }) {
  const { user } = useSelector((state) => state.auth);
  const dept = departmentTitle
    || user?.departments?.find((d) => d.id == departmentId)?.title;
  const parts = [dept, serviceTitle].filter(Boolean);
  if (!parts.length) return null;
  return (
    <div className="selection-path">
      {parts.map((p, i) => (
        <span key={i} className="selection-path-item">
          {i > 0 && <span className="selection-path-dot">·</span>}
          {p}
        </span>
      ))}
    </div>
  );
}
